export const requestErrors = {
  API_URL_NOT_DEFINED: 'API URL is not defined',
  CUSTOMER_ID_NOT_DEFINED: 'Customer ID is not defined',
  SUBSCRIPTION_DATA_NOT_FOUND: 'Subscription data not found',
  SUBSCRIPTIONS_DATA_NOT_FOUND: 'Subscriptions data not found',
  ORDER_DATA_NOT_FOUND: 'Order data not found',
  ORDERS_DATA_NOT_FOUND: 'Orders data not found'
} as const;
